import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbar1Bar26X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 1.846c4.468 0 7.446 2.437 7.742 2.659l-7.736 9.643-.006.006-.006-.012-.684-.853-2.793-3.474.002-.001-4.26-5.31C.553 4.285 3.531 1.847 8 1.847"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbar1Bar26X24Px
